import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=8942c580"
import script from "../../../js/home/manager/RoleManager.js?vue&type=script&lang=js&external"
export * from "../../../js/home/manager/RoleManager.js?vue&type=script&lang=js&external"
import style0 from "../../../css/home/manager/RoleManager.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports